module.exports = __webpack_public_path__ + "img/hero-5.1ccf4eb0.png";